import { Common, ApiBind } from './common.model';

export class ResponseTsvData extends Common {

  @ApiBind({ column: 'data' })
  data: string;

  @ApiBind({ column: 'file_name' })
  fileName: string;

}
